import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { OrderLine } from '../../../../../../data/models/transaction/op/outbound/order/index';
import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class OnlineOrderLineService {
    constructor(private http: AuthHttp) { }

	getAvailableInvPackDetails(ownerCode: string, warehouseCode: string, orderType: string, deliveryDateString: string,  $event: any) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("warehouseCode", warehouseCode);
        params.set("orderType", orderType);
        params.set("deliveryDateString", deliveryDateString);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.post(AppSettings.apiEndpoint + "OnlineShipmentOrderLine/GetAvailableInvPackDetails", $event, options)
            .map((response: Response) => response.json());
    }

    getAvailableInvPackDetailsByProdCode(ownerCode: string, warehouseCode: string, orderType: string, deliveryDateString: string,  productCode: any) {
      let params: URLSearchParams = new URLSearchParams();
      params.set("ownerCode", ownerCode);
      params.set("warehouseCode", warehouseCode);
      params.set("orderType", orderType);
      params.set("deliveryDateString", deliveryDateString);
      params.set("productCode", productCode);

      let options: RequestOptions = new RequestOptions({ search: params });
      return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderLine/GetAvailableInvPackDetailsByProductCode", options)
          .map((response: Response) => response.json());
  }

    getOnlineShipmentOrderLinesByOrder(ownerCode: string, onlineOrderNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("onlineOrderNo", onlineOrderNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderLine/GetOnlineShipmentOrderLinesByOrder", options)
            .map((response: Response) => response.json());
    }

    createOnlineShipmentOrderLines(orderLines: OrderLine[]) {
        return this.http.post(AppSettings.apiEndpoint + "OnlineShipmentOrderLine/CreateOnlineShipmentOrderLines", orderLines)
            .map((response: Response) => response.json());
    }

    getAvailableInvPackDetailsProdInv(ownerCode: string, warehouseCode: string, orderType: string, deliveryDateString: string,  $event: any) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("warehouseCode", warehouseCode);
        params.set("orderType", orderType);
        params.set("deliveryDateString", deliveryDateString);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.post(AppSettings.apiEndpoint + "OnlineShipmentOrderLine/GetAvailableInvPackDetailsProdInv", $event, options)
            .map((response: Response) => response.json());
    }

    GetOnlineShipmentOrderLineGST(ownerCode: string, oopOrderNo: string, lineNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("oopOrderNo", oopOrderNo);
        params.set("lineNo", lineNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderLine/GetOnlineShipmentOrderLineGST", options)
            .map((response: Response) => response.json());
    }

    GetOnlineShipmentOrderGST(ownerCode: string, oopOrderNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("oopOrderNo", oopOrderNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderLine/GetOnlineShipmentOrderGST", options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/online-order-line.service.ts